import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import SmsPolicy from './pages/SmsPolicy';
import OptOut from './pages/OptOut';
import Industries from './pages/Industries';
import CaseStudies from './pages/CaseStudies';
import FAQ from './pages/FAQ';
import Accessibility from './pages/Accessibility';
import NotFound from './pages/NotFound';
import ComplianceCenter from './pages/ComplianceCenter';
import CookieConsent from './components/CookieConsent';
import BusinessVerification from './pages/BusinessVerification';
import './App.css';

function App() {
	return (
		<HelmetProvider>
			<Router>
				<div className="App">
					<ScrollToTop />
					<Header />
					<main id="main" className="main-container">
						<Routes>
							<Route path="/" element={<Home />} />
							<Route path="/services" element={<Services />} />
							<Route path="/industries" element={<Industries />} />
							<Route path="/case-studies" element={<CaseStudies />} />
							<Route path="/faq" element={<FAQ />} />
							<Route path="/about" element={<About />} />
							<Route path="/contact" element={<Contact />} />
							<Route path="/privacy" element={<PrivacyPolicy />} />
							<Route path="/terms" element={<Terms />} />
							<Route path="/compliance" element={<ComplianceCenter />} />
							<Route path="/sms-policy" element={<SmsPolicy />} />
							<Route path="/opt-out" element={<OptOut />} />
							<Route path="/accessibility" element={<Accessibility />} />
							<Route path="/business-verification" element={<BusinessVerification />} />
							<Route path="*" element={<NotFound />} />
						</Routes>
					</main>
					<Footer />
					<CookieConsent />
				</div>
			</Router>
		</HelmetProvider>
	);
}

export default App;


